const SET_MODAL_OVERLAY_VISIBILITY = 'setModalOverlayVisibility';
export default SET_MODAL_OVERLAY_VISIBILITY;
